import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import {
  FlagGroupTag,
  Inspection,
  Inspector,
  ListFilters,
  ListResults,
  Question,
  QuestionTag,
  Section,
} from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class QuestionService {
  relatedCache: { [key: number]: any } = {};

  constructor(protected http: HttpClient) {}

  list(filters: ListFilters) {
    return this.http.get<ListResults<Question>>(`${env.APIUrl}/question`, { params: filters as any });
  }
  pick(versionName: string) {
    return this.http.get<Question[]>(`${env.APIUrl}/question/pick`, { params: { versionName } }).toPromise();
  }

  get(id: number, versionName: string) {
    return this.http.get<Question>(`${env.APIUrl}/question/${id}`, { params: { versionName } }).toPromise();
  }

  getRelated(id: number, version: number, inspectionVersion: number) {
    if (
      !this.relatedCache[id] ||
      !this.relatedCache[id][version] ||
      this.relatedCache[id][version][inspectionVersion]
    ) {
      this.relatedCache[id] = this.relatedCache[id] || {};
      this.relatedCache[id][version] = this.relatedCache[id][version] || {};
      this.relatedCache[id][version][inspectionVersion] = this.http
        .get<Question[]>(`${env.APIUrl}/question/${id}/version/${version}/related`, {
          params: { inspectionVersion: inspectionVersion.toString() },
        })
        .toPromise();
    }

    return this.relatedCache[id][version][inspectionVersion];
  }

  archived(filters: ListFilters) {
    return this.http
      .get<ListResults<Question>>(`${env.APIUrl}/question/archived`, { params: filters as any })
      .toPromise();
  }

  archive(id: number, versionName: string) {
    return this.http
      .put<Question>(`${env.APIUrl}/question/${id}/archive`, null, { params: { versionName } })
      .toPromise();
  }

  restore(id: number) {
    return this.http.put<Question>(`${env.APIUrl}/question/${id}/restore`, null).toPromise();
  }

  edit(id: number, question: Question, versionName: string) {
    return this.http.put<Question>(`${env.APIUrl}/question/${id}`, question, { params: { versionName } }).toPromise();
  }

  move(section: Section, id: number, newPosition: number, versionName: string) {
    return this.http
      .post<boolean>(`${env.APIUrl}/question/${id}/move`, { newPosition, section }, { params: { versionName } })
      .toPromise();
  }

  create(question: Question, versionName: string) {
    return this.http.post<Question>(`${env.APIUrl}/question`, question, { params: { versionName } }).toPromise();
  }

  inspectors(questionId: number, search = '') {
    return this.http.get<Inspector[]>(`${env.APIUrl}/question/${questionId}/inspectors`, { params: { search } });
  }

  inspections(questionId: number) {
    return this.http.get<Inspection[]>(`${env.APIUrl}/question/${questionId}/inspections`);
  }

  uploadPicture(formData) {
    return this.http.post<any>(`${env.APIUrl}/image/upload`, formData).toPromise();
  }

  getFlagGroupTags() {
    return this.http.get<FlagGroupTag[]>(`${env.APIUrl}/question/flagGroupTags`).toPromise();
  }

  getQuestionTags() {
    return this.http.get<QuestionTag[]>(`${env.APIUrl}/question/questionTags`).toPromise();
  }
  listByInspectionVersion(versionId: number) {
    return this.http.get<Question[]>(`${env.APIUrl}/question/listByInspectionVersion/${versionId}`).toPromise();
  }
}
